import React, { useState, useRef, useEffect } from 'react';
import './ClientPicker.css';

// "Ángel" se encuentra escribiendo "an": se comparan sin acentos ni mayúsculas
const normaliza = (texto) => (texto || '')
  .normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

// Con una o dos letras, buscar "en cualquier parte" saca casi todo el catálogo
// (medido: "a" devolvía 183 de 251). A partir de tres ya discrimina.
const MIN_LETRAS_PARA_BUSCAR_DENTRO = 3;

/** Desplegable de clientes que filtra por el PRINCIPIO del nombre.
 *  El <datalist> del navegador filtra por cualquier parte y no se puede cambiar,
 *  así que con 252 clientes escribir "A" sacaba medio catálogo. */
const ClientPicker = ({ clients, value, onChange, id = 'cliente', placeholder = '' }) => {
  const [abierto, setAbierto] = useState(false);
  const [resaltado, setResaltado] = useState(0);
  const contenedor = useRef(null);

  // Primero los que EMPIEZAN por lo escrito, y debajo los que lo llevan en medio
  // ("abain" también encuentra "INDUSTRIAS ABAIN", pero sin tapar a ABAIN).
  const escrito = normaliza(value);
  const empiezan = escrito ? clients.filter((c) => normaliza(c.name).startsWith(escrito)) : clients;
  const contienen = escrito.length >= MIN_LETRAS_PARA_BUSCAR_DENTRO
    ? clients.filter((c) => !normaliza(c.name).startsWith(escrito) && normaliza(c.name).includes(escrito))
    : [];
  const opciones = [...empiezan, ...contienen];

  useEffect(() => {
    const fuera = (e) => {
      if (contenedor.current && !contenedor.current.contains(e.target)) setAbierto(false);
    };
    document.addEventListener('mousedown', fuera);
    return () => document.removeEventListener('mousedown', fuera);
  }, []);

  const elegir = (nombre) => {
    onChange(nombre);
    setAbierto(false);
  };

  const teclado = (e) => {
    if (e.key === 'Escape') return setAbierto(false);
    if (!abierto && ['ArrowDown', 'ArrowUp'].includes(e.key)) return setAbierto(true);
    if (e.key === 'ArrowDown') setResaltado((i) => Math.min(i + 1, opciones.length - 1));
    if (e.key === 'ArrowUp') setResaltado((i) => Math.max(i - 1, 0));
    if (e.key === 'Enter' && abierto && opciones[resaltado]) {
      e.preventDefault();
      elegir(opciones[resaltado].name);
    }
  };

  return (
    <div className="client-picker" ref={contenedor}>
      <input
        id={id}
        value={value || ''}
        placeholder={placeholder}
        autoComplete="off"
        onChange={(e) => { onChange(e.target.value); setAbierto(true); setResaltado(0); }}
        onFocus={() => setAbierto(true)}
        onKeyDown={teclado}
      />
      {abierto && opciones.length > 0 && (
        <ul className="client-picker-lista">
          {opciones.map((c, i) => (
            <React.Fragment key={c.hash}>
              {i === empiezan.length && empiezan.length > 0 && (
                <li className="client-picker-separador">También lo llevan en el nombre</li>
              )}
              <li>
                <button
                  type="button"
                  className={i === resaltado ? 'activa' : ''}
                  onMouseEnter={() => setResaltado(i)}
                  onClick={() => elegir(c.name)}
                >
                  {c.name}
                </button>
              </li>
            </React.Fragment>
          ))}
        </ul>
      )}
      {abierto && escrito && opciones.length === 0 && (
        <ul className="client-picker-lista">
          <li className="client-picker-nuevo">Ningún cliente se llama así. Se creará nuevo.</li>
        </ul>
      )}
    </div>
  );
};

export default ClientPicker;
